import get from 'transmute/get';
import { TYPE } from '../constants/keyPaths';
export const getMessageType = get(TYPE);